// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_PRODUCT_FILTERS_SETTING: `${env.baseApiUrl}/im/admin/product-filter/setting`,
  GET_PRODUCT_SEARCH_SETTING: `${env.baseApiUrl}/winehouse/admin/product/search-setting`,
  SAVE_PRODUCT_SEARCH_SETTING: `${env.baseApiUrl}/winehouse/admin/product/search-setting`,
  GET_VECTORIZE_STATUS: `${env.baseApiUrl}/winehouse/admin/product/vectorize/status`,
});

export type ProductFilterSettingRequest = {
  promotionFilter?: {
    enabled: boolean,
  },
  productVariantOptionFilter?: {
    enabled?: boolean,
    productVariantOptionIds?: string[],
  },
};

export type ProductSearchSettingRequest = {
  enabled: boolean,
};

export type ProductSearchSettingResponse = {
  enabled: boolean,
  includeProductSections: boolean,
};

export type VectorizeStatusResponse = {
  id: string,
  state: string,
  metadata: any,
  productIds: {
    productIds: string[] | null,
  },
  createdAt: string,
  updatedAt: string,
};

export const getProductFiltersSettingApi = getCreator(
  endpoints.GET_PRODUCT_FILTERS_SETTING
);

export const saveProductFiltersSettingApi = postCreator(
  endpoints.GET_PRODUCT_FILTERS_SETTING
);

export const getProductSearchSettingApi = getCreator(
  endpoints.GET_PRODUCT_SEARCH_SETTING
);

export const saveProductSearchSettingApi = postCreator(
  endpoints.SAVE_PRODUCT_SEARCH_SETTING
);

export const getVectorizeStatusApi = getCreator(endpoints.GET_VECTORIZE_STATUS);
